export default __webpack_public_path__ + "027dd831320669dbf48783f8080c5b48.png";